export const GET_TASK = 'GET_TASK';
export const TASK_RESPONSE = 'TASK_RESPONSE';
